import { get, post, put } from './';
import * as Api from './v2';
import { accountEntry, contract, contractDocument, contractFolder, moneyOrder, transaction } from './schema';
import { SERGIC_OFFER } from '../constants';

export const getUserContracts = () =>
   get(`/v1/users/me/contracts?by_sergic_offer=${SERGIC_OFFER}`, { schema: [contract] });

export const getUserContractsV2 = ({ params }) =>
   Api.get(`/v1/users/me/contracts`, {
      params: {
         bySergicOffer: SERGIC_OFFER,
         ...params,
      },
   });
export const getContract = id => get(`/v1/contracts/${id}`, { schema: contract });
export const getContractAccountEntries = ({ sliceId, params }) =>
   get(`/v1/contracts/${sliceId}/account_entries?${params}`, { schema: [accountEntry] });
export const getContractAccountEntriesSubtotal = ({ contractId, date }) =>
   get(`/v1/contracts/${contractId}/account_entries/subtotal?date=${date}`);
export const postContractInvitations = ({ id, payload }) => post(`/v1/contracts/${id}/invitations`, payload);
export const destroyContractInvitations = ({ id, payload }) => post(`/v1/contracts/${id}/revoke`, { revoke: payload });
export const getContractInvitationsByEmailOrContactId = ({ placeId, type, value }) =>
   get(`/v1/contract_invitations?by_place=${placeId}&${type}=${value}`);
export const getContractMoneyOrder = contractId =>
   get(`/v1/contracts/${contractId}/money_order`, { schema: moneyOrder });
export const postContractMoneyOrder = ({ contractId, payload }) =>
   post(`/v1/contracts/${contractId}/money_order`, payload, { schema: moneyOrder });
export const putContractMoneyOrder = ({ contractId, payload }) =>
   put(`/v1/contracts/${contractId}/money_order`, payload);
export const getMoneyOrderSigningURL = contractId => get(`/v1/contracts/${contractId}/money_order/sign?ua=web`);

export const postContractTransaction = ({ contractId, payload }) =>
   post(`/v1/contracts/${contractId}/transactions`, payload);
export const updateContractPreferences = ({ contractId, payload }) =>
   put(`/v1/users/me/contracts/${contractId}/convocation_setting`, payload, { schema: contract });

export const postPreEtatDateRequest = ({ contractId, payload }) =>
   post(`/v1/contracts/${contractId}/pre_etat_date_requests`, payload);

export const getContractTransactions = ({ sliceId, params }) =>
   get(`/v1/contracts/${sliceId}/transactions?${params}`, { schema: [transaction] });

export const getContractFolders = ({ params }) =>
   get(`/v2/contract_folders?${params.replace('?', '')}`, { schema: [contractFolder] });

export const getContractFolderDocuments = ({ sliceId, params }) =>
   get(`/v2/contracts/${sliceId}/contract_documents?${params.replace('?', '')}`, { schema: [contractDocument] });
export const getContractDocument = id => Api.get(`/v1/contract_documents/${id}`);
export const getCoownershipDocument = id => Api.get(`/v1/coownership_documents/${id}`);
